module.exports = __webpack_public_path__ + "img/IMG_0845.a73bac50.jpeg";